var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewLogoCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#0F1117"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4443 20.2591V30.3704H30.1113L31.5371 33.8704L29.9814 34.6478L25.0557 30.3704H7.55566V20.2591L20 10.7962L32.4443 20.2591ZM24.1836 23.8304C23.7392 23.7197 23.2974 23.9973 23.0859 24.4036C22.8563 24.845 22.5336 25.2356 22.1377 25.5472C21.5229 26.031 20.7648 26.2966 19.9824 26.3021C19.2 26.3075 18.438 26.0527 17.8164 25.5775C17.4162 25.2715 17.0883 24.8857 16.8525 24.4476C16.6355 24.0443 16.1899 23.7723 15.7471 23.889C15.3041 24.006 15.0336 24.4644 15.2197 24.8831C15.5707 25.6724 16.1154 26.3659 16.8086 26.8958C17.7227 27.5946 18.8435 27.9693 19.9941 27.9612C21.1447 27.9531 22.2598 27.5624 23.1641 26.8509C23.8497 26.3113 24.3848 25.6107 24.7246 24.8167C24.9048 24.3955 24.6281 23.9413 24.1836 23.8304ZM16.1113 18.055C15.2524 18.055 14.5559 18.7518 14.5557 19.6107C14.5557 20.4698 15.2522 21.1663 16.1113 21.1663C16.9703 21.1662 17.667 20.4697 17.667 19.6107C17.6667 18.7518 16.9702 18.0551 16.1113 18.055ZM23.8887 18.055C23.0299 18.0552 22.3333 18.7519 22.333 19.6107C22.333 20.4697 23.0297 21.1662 23.8887 21.1663C24.7477 21.1663 25.4443 20.4697 25.4443 19.6107C25.4441 18.7518 24.7476 18.055 23.8887 18.055ZM37.5 18.8333L35.4258 20.5189L20 8.85187L4.57422 20.5189L2.5 18.8333L20 5.35187L37.5 18.8333Z",
    fill: "url(#paint0_linear_3337_1448)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3337_1448",
    x1: 20,
    y1: 5.35187,
    x2: 20,
    y2: 34.6478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA8ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#1155C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoCollapse);
export default __webpack_public_path__ + "static/media/NewLogoCollapse.2bd87c7e9564db33a0d48cf0d6b64bd4.svg";
export { ForwardRef as ReactComponent };